import { withErrorCode } from '@/lib/errors'
import type { UseFormRegister, FieldErrors } from 'react-hook-form'
import { MagicInput as Input } from '@/components/ui/magic-input'
import { Label } from '@/components/ui/label'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

export interface ApplicantInfo {
  firstName: string
  lastName: string
  email: string
}

interface Props {
  register: UseFormRegister<{ applicantInfo: ApplicantInfo; [key: string]: unknown }>
  errors: FieldErrors<{ applicantInfo: ApplicantInfo }>
}

export function ApplicantInfoSection({ register, errors }: Props) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Your Information</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-1">
            <Label htmlFor="firstName">
              First Name <span className="text-destructive">*</span>
            </Label>
            <Input
              id="firstName"
              placeholder="Jane"
              {...register('applicantInfo.firstName', {
                required: 'First name is required',
                maxLength: { value: 500, message: 'First name is too long' },
              })}
            />
            {errors.applicantInfo?.firstName && (
              <p className="text-sm text-destructive">
                {withErrorCode(String(errors.applicantInfo.firstName.message), 'app/validation')}
              </p>
            )}
          </div>
          <div className="space-y-1">
            <Label htmlFor="lastName">
              Last Name <span className="text-destructive">*</span>
            </Label>
            <Input
              id="lastName"
              placeholder="Doe"
              {...register('applicantInfo.lastName', {
                required: 'Last name is required',
                maxLength: { value: 500, message: 'Last name is too long' },
              })}
            />
            {errors.applicantInfo?.lastName && (
              <p className="text-sm text-destructive">
                {withErrorCode(String(errors.applicantInfo.lastName.message), 'app/validation')}
              </p>
            )}
          </div>
        </div>
        <div className="space-y-1">
          <Label htmlFor="email">
            Email <span className="text-destructive">*</span>
          </Label>
          <Input
            id="email"
            type="email"
            placeholder="jane@example.com"
            {...register('applicantInfo.email', {
              required: 'Email is required',
              maxLength: { value: 254, message: 'Email is too long' },
              pattern: { value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: 'Invalid email address' },
            })}
          />
          {errors.applicantInfo?.email && (
            <p className="text-sm text-destructive">
              {withErrorCode(String(errors.applicantInfo.email.message), 'app/validation')}
            </p>
          )}
        </div>
      </CardContent>
    </Card>
  )
}
